import React from 'react'
import { ProjectActionModalProps } from './Types/types'

const ProjectActionModal: React.FC<ProjectActionModalProps> = ({ projectAction }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: '85%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <div
        style={{
          width: '350px',
          height: '55px',
          backgroundColor: '#3E3F42',
          borderRadius: '5px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <p style={{ color: 'white', fontSize: '14px' }}>
          {projectAction === 'create' && 'New Project Created'}
          {projectAction === 'edit' && 'Project Updated'}
          {projectAction === 'delete' && 'Project Deleted'}
          {projectAction === 'archive' && 'Project Archived'}
          {projectAction === 'unarchive' && 'Project Unarchived'}
        </p>
      </div>
    </div>
  )
}

export default ProjectActionModal
